import { faFacebookF } from "@fortawesome/free-brands-svg-icons/faFacebookF"
import { faFacebookMessenger } from "@fortawesome/free-brands-svg-icons/faFacebookMessenger"
import { faPinterest } from "@fortawesome/free-brands-svg-icons/faPinterest"
import { faXTwitter } from "@fortawesome/free-brands-svg-icons/faXTwitter"
import { faShareAlt as faShareAltOutline } from "@jewlr/pro-light-svg-icons/faShareAlt"
import { faShareAlt } from "@jewlr/pro-solid-svg-icons/faShareAlt"
import {
  Button,
  FontAwesomeIcon,
  MediaFlex,
  Typography,
} from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import { generateSourceURL, shorten_url } from "helpers/analytics-helpers"
import { isTestMode } from "helpers/application"
import socialShare from "helpers/social-share"
import WebShareApi from "helpers/web-share-api"
import useWindowDimensions from "helpers/window-dimensions"

const SocialIcon = styled(Button).attrs({
  variant: "text",
})`
  align-items: center;
  color: ${(props) => props.theme.colors.primary};
  font-size: 22px;
`
const ShareType = styled(Typography)`
  color: ${(props) => props.theme.colors.primary};
  display: none;
  margin-left: ${(props) => props.theme.space[1]};
  ${({ theme }) => theme.mediaQueries.tablet`
    display: block;
    font-size: 14px;
  `}
`
const WebShare = styled(Button)`
  align-items: center;
  color: ${(props) => props.theme.colors.primary};
  display: flex;
  font-size: "16px",
  font-weight: "700",
  justify-content: center;
  margin: 10px auto 0;
  ${(props) => props.theme.mediaQueries.desktop`
    display: none;
  `}
`

const InternalSocialShare = ({ doNativeShare, socialShare }) => {
  const [nativeShare, setNativeShare] = useState(true)
  const { isMobile } = useWindowDimensions()

  useEffect(() => {
    if (!WebShareApi.shareIsSupported()) {
      setNativeShare(false)
    }
  }, [])

  return (
    <>
      {nativeShare && (
        <WebShare onClick={(e) => doNativeShare(e)}>
          Share{" "}
          <FontAwesomeIcon
            fontSize="21px"
            icon={isMobile ? faShareAltOutline : faShareAlt}
            pl="4px"
          />
        </WebShare>
      )}

      <MediaFlex
        greaterThanOrEqual="desktop"
        justifyContent="space-around"
        px={5}
        py={3}
      >
        <SocialIcon onClick={(e) => socialShare("Facebook", e)}>
          <FontAwesomeIcon icon={faFacebookF} />
          <ShareType>Share</ShareType>
        </SocialIcon>
        <SocialIcon onClick={(e) => socialShare("Twitter", e)}>
          <FontAwesomeIcon icon={faXTwitter} />
          <ShareType>Post</ShareType>
        </SocialIcon>
        <SocialIcon onClick={(e) => socialShare("Pinterest", e)}>
          <FontAwesomeIcon icon={faPinterest} />
          <ShareType>Pin it</ShareType>
        </SocialIcon>
        <SocialIcon onClick={(e) => socialShare("Messenger", e)}>
          <FontAwesomeIcon icon={faFacebookMessenger} />
          <ShareType>Send</ShareType>
        </SocialIcon>
      </MediaFlex>
    </>
  )
}

// Genearte product default params url
const getParams = (state) => {
  let qs = "" //'style_code=' + style_code;
  let choices = state.choices
  let choice_keys = Object.keys(choices)
  for (let i = 0; i < choice_keys.length; i++) {
    qs +=
      "&" +
      choice_keys[i] +
      "=" +
      encodeURIComponent(choices[choice_keys[i]].value || "")
  }
  return qs
}

const mapStateToProps = (state) => {
  return {
    defaultParams: getParams(state),
    state,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const gtmEvent = (state, share_type) => {
  // GTM record event
  if (!isTestMode) {
    dataLayer.push({
      currencyCode: state.wizard.price_and_promo.currency_code,
      event: "product-shared",
      sharedMethod: share_type,
      styleCode: state.choices.style_code?.value,
    })
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { state, defaultParams } = stateProps

  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    doNativeShare: (e) => {
      e.preventDefault()

      if (!state.wizardUI.prefStore) {
        return
      }

      gtmEvent(state, "Native")

      const share_url = generateSourceURL(
        `${state.wizard.shareUrl}?${defaultParams}`,
        "native"
      )

      WebShareApi.triggerWebShare(
        "Jewlr",
        `Check this out from Jewlr! ${state.wizard.title}`,
        share_url,
        (err) => {
          if (err) {
            console.log(err)
          }
        }
      )
    },
    socialShare: async (share_type, e) => {
      let popup = null
      if (share_type == "Twitter" || share_type == "Pinterest") {
        popup = window.open("", "_blank", "status=1,width=650,height=550")
      }
      e.preventDefault()

      if (!state.wizardUI.prefStore) {
        return
      }

      gtmEvent(state, share_type)

      // Shorten share url
      let share_url = `${state.wizard.shareUrl}?${defaultParams}`
      share_url = await shorten_url(generateSourceURL(share_url, share_type))

      let images = {
        ...state.wizard.images,
        ...state.previewImage.data.images,
      }
      let imageUrl = images["share_view"].src
      let share_properties = {
        clickLabel: state.choices.style_code?.value,
        clickType: `Product ${share_type} Share`,
        imageUrl: imageUrl,
        message: `Check this out from Jewlr! ${state.wizard.title}`,
        popup,
        url: share_url,
      }

      socialShare({ share_type: share_type, ...share_properties })
    },
  }
}

InternalSocialShare.propTypes = {
  doNativeShare: PropTypes.func.isRequired,
  socialShare: PropTypes.func.isRequired,
}

const SocialShare = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(InternalSocialShare)

export default SocialShare
